import { Container } from "@mui/material";
import Navigation from "./AppBar";
import Footer from "./Footer";

export default function DefaultLayout({ children }) {
  return (
    <Container
      disableGutters={true}
      maxWidth={false}
      sx={{
        backgroundColor: "rgb(248,248,248)",
      }}
    >
      <Navigation />
      <main style={{ flexGrow: 1 }}>{children}</main>
      <Footer />
    </Container>
  );
}
